module.exports = __webpack_public_path__ + "img/icon-default-seafood.96107791.png";